import { FC } from 'react'
import { ColorOptions, FontSizeOptions } from '../../theme/UiThemeProvider'
import { Text } from '../Text'
// import water_icon from '/assets/icons/water_icon.svg'
import mobile_recharge from '../../assets/images/mobile_recharge.svg'
import fastag from '../../assets/images/fastag.svg'
import electricity from '../../assets/images/electricity.svg'
import dth from '../../assets/images/dth.svg'
import book_lpg from '../../assets/images/book_lpg.svg'
import credit_card from '../../assets/images/credit_card.svg'
import fiber from '../../assets/images/fiber.svg'
import mobile_postpaid from '../../assets/images/mobile_postpaid.svg'
import water_icon from '../../assets/images/water_icon.svg'
import landline_icon from '../../assets/images/landline_icon.svg'
import piped_gas from '../../assets/images/piped_gas.svg'
import broadbank_icon from '../../assets/images/broadbank_icon.svg'
import cable_tv from '../../assets/images/cable_tv.svg'
import loan_payment from '../../assets/images/loan_payment.svg'
import recurring_deposite from '../../assets/images/recurring_deposite.svg'
import Insurance from '../../assets/images/Insurance.svg'
import municiple_tax from '../../assets/images/municiple_tax.svg'
import rent_icon from '../../assets/images/rent_icon.svg'
import housing_society from '../../assets/images/housing_society.svg'
import subscription_icon from '../../assets/images/subscription_icon.svg'
import club_association from '../../assets/images/club&association.svg'
import hospital_path from '../../assets/images/hospital_path.svg'
import education_fee from '../../assets/images/education_fee.svg'

export const IconIds = {
  HOME: '\ue902',
  LOGO: '\ue9fb',
  SEARCH: '\ue93a',
  SHARE: '\ue937',
  CLOSE: '\ue925',
  CLEAR: '\ue915',
  LOCATE: '\ue9e6',
  LOCATION: '\ue9fd',
  SOCIETY: '\uea23',
  HISTORY: '\ue90c',
  ARROW_UP: '\ue953',
  ARROW_DOWN: '\ue954',
  SUCCESSFUL_EMPTY: '\ue935',
  SUCCESSFUL_FILLED: '\ue934',
  TICKMARK: '\ue91d',
  RADIOBUTTON_ON: '\ue929',
  RADIOBUTTON_OFF: '\ue92a',
  CHECKBOX_OUTLINE: '\ue94e',
  CHECKBOX_UNCHECKED: '\ue94d',
  CHECKBOX_CHECKED: '\ue950',
  STATUS_SUCCESS: '\ue91d',
  STATUS_PENDING: '\ue942',
  STATUS_AWAITING: '\ue901',
  STATUS_FAILED: '\ue925',
  GOLD_SAVINGS_PLAN: '\ue975',
  BUY_GOLD: '\uea06',
  INCREMENT: '\uea11',
  DECREMENT: '\uea10',
  ARROW_BACK: '\ue921',
  ARROW_RIGHT: '\ue952',
  ARROW_LEFT: '\ue955',
  TIMER: '\ue901',
  FILTER: '\ue92c',
  FILTER2: '\ue9a2',
  FAQ: '\ue946',
  CART: '\ue98f',
  CART_FILLED: '\ue815',
  DOWNLOAD: '\ue947',
  CALENDAR: '\ue94f',
  LOCK: '\ue969',
  INFO: '\ue942',
  DEFAULT_CARD: '\ue94b',
  ICON_CLOSE: '\ue925',
  ICON_REFRESH: '\ue9b1',
  STAR_FILLED: '\ue99a',
  WALLET: '\ue940',
  STAR: '\ue99b',
  USER: '\ue92f',
  SORT: '\ue9f0',
  FAVOURITE: '\ue90f',
  FAVOURITE_FILLED: '\ue96e',
  LIST_SORT: '\ue9a5',
  LOCATION_MAP: '\ue963',
  EDIT: '\ue90b',
  MENU: '\ue917',
  RESTAURANT: '\ue9e9',
  WIFI: '\ue982',
  PARKING: '\ue9a9',
  CALL: '\uea0e',
  ROOM_SERVICE: '\ue9c9',
  SETTING: '\ue936',
  NEWBILLER: '\ue932',
  NOTIFICATION: '\ue92b',
  DELETE: '\ue949',
  STOP: '\ue9b0',
  ADD: '\ue959',
  OPTIONS: '\ue916',
  PAYLATER: '\ue93b',
  CONTACTS: '\ue99f',
  ADDBILLER: '\ue93d',
  BANK: '\ue95b',
  ROUND_TICK: '\ue935',
  ROUND_TICK_FILLED: '\ue934',
  SHOP: '\ue908',
  EXCLAMATION: '\ue948',
  EYE_WATCH: '\uE930',
  EYE_WATCH_SELECTED: '\ue927',
  THUMB_VIEW: '\ue9a1',
  LOAD_MONEY: '\ue971',
  LAYERS: '\ue95e',
  UPLOAD: '\ue928',
  FILTER3: '\ue9ae',
  ACCOUNT: '\ue95a',
  TRANSACTIONS: '\uE9D5',
  SETTLEMENTS: '\uE974',
  PLANS: '\uE986',
  REFUNDS: '\uE93B',
  INVOICES: '\uE9FE',
  CAMERA: '\uE923',
  SCAN_QR: '\ue95f',
  VIDEOS: '\ue9c2',
  SUPPORT: '\ue9b3',
  LOGOUT: '\ue90a',
  DUPLICATE: '\ue986',
  MOBILE: '\ue9ed',
  DTH: '\ue9b9',
  DATA_CARD: '\ue993',
  ELECTRICITY: '\ue980',
  CYLINDER: '\ue9aa',
  INSURANCE: '\ue9bb',
  LANDLINE: '\ue9ef',
  CHARITY: '\ue975',
  BROADBAND: '\ue989',
  WATER: '\ue9ff',
  HOUSING: '\uea23',
  MUNICIPAL_TAX: '\uea20',
  MUTUAL_FUND: '\ue809',
  JIO_PAYMENTS: '\ue9b6',
  TOLL: '\uea0d',
  FASTAG: '\uea0d',
  EDUCATION: '\ue9d2',
  GIFT_CARD: '\ue988',
  MAX_LIMIT: '\uea13',
  PAYMENT_LINKS: '\uEA22',
  INSIGHTS: '\uE90E',
  BULK_REFUND: '\uE9E5',
  JIO_ICON: '\ue9f5',
  HAMBURGER_MENU: '\ue93c',
  JIO_MONEY: '\ue9fb',
  EMAIL: '\ue97e',
  FINGERPRINT: '\ue943',
  CASH_WITHDRAWL: '\ue9d0',
  FUND_TRANSFER: '\uea13',
  CASH_DEPOSIT: '\ue971',
  BALANCE_ENQUIRY: '\ue951',
  MINI_STATEMENT: '\ue9fe',
  TNX_ENQUIRY: '\ue933',
  CARD_CVV: '\ue95c',
  EMI: '\ue9f4',
  MY_ACCOUNT: '\ue97a',
  CONTACT_US: '\ue938',
  TOKEN: '\ue973',
  ADD_USER: '\ue924',
  CUSTOMIZE: '\ue93e',
  SMILE: '\ue966',
  ARROWS: '\ue97c',
  MOBILE_CARD: '\ue945',
  TOKENIZED_CARD: '\ue9ca',
  BARCODE: '\uE912',
  BLOCK: '\ue9b0',
  UNBLOCK: '\ue9ac',
  HAMBURGER_OPTIONS: '\ue90D',
  VAULT: '\ue814',
  IMPORT: '\ue98a',
  FAST_TAG: '\uea2b',
  CHAT: '\ue926',
  CIRCLE: '\u2B24',
}

export const SvgIcons = {
  mobile_recharge_icon: mobile_recharge,
  fastag_icon: fastag,
  electricity_icon: electricity,
  dth_icon: dth,
  book_lpg_icon: book_lpg,
  credit_card_icon: credit_card,
  fiber_icon: fiber,
  mobile_postpaid_icon: mobile_postpaid,
  water_icon_icon: water_icon,
  landline_icon_icon: landline_icon,
  piped_gas_icon: piped_gas,
  broadbank_icon_icon: broadbank_icon,
  cable_tv_icon: cable_tv,
  loan_payment_icon: loan_payment,
  recurring_deposite_icon: recurring_deposite,
  insurance_icon: Insurance,
  municiple_tax_icon: municiple_tax,
  rent_icon_icon: rent_icon,
  housing_society_icon: housing_society,
  subscription_icon: subscription_icon,
  club_and_association_icon: club_association,
  hospital_path_icon: hospital_path,
  education_fee_icon: education_fee,
};

export type IconOptions = keyof typeof IconIds
export const IconIdsOptionArray = Object.keys(IconIds)
export type SvgIconOptions = keyof typeof SvgIcons;

interface IconProps {
  id: IconOptions
  svgId?: SvgIconOptions
  size?: FontSizeOptions | number
  color?: ColorOptions
  hide?: boolean
}

export const Icon: FC<IconProps> = ({ id,svgId, size = 'FONT_SIZE_MEDIUM', color = 'PRIMARY', hide = false }) => {
  if (hide) {
    return null
  }

  if (svgId && SvgIcons[svgId]) {
    // If it's an SVG, return an <img> element
    return <img src={SvgIcons[svgId]} alt={svgId} style={{ width: size, height: size }} />;
  }

  return (
    <Text fontSize={size} color={color} fontFamily="JioMoney">
      {IconIds[id]}
    </Text>
  )
}
